import HRUpdateSkill from "src/components/skill/hr/UpdateSkill";

export default function UpdateSkill() {
    return (
        <div className="w-11/12 max-w-7xl mx-auto">
            <HRUpdateSkill />
        </div>
    )
}